var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#139D29",
  d: "M7.5 13.5 4 10l-1.167 1.167L7.5 15.833l10-10-1.167-1.166L7.5 13.5Z"
})));
export { SvgDone as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNDk5OTIgMTMuNTAwMUwzLjk5OTkyIDEwLjAwMDFMMi44MzMyNSAxMS4xNjY3TDcuNDk5OTIgMTUuODMzNEwxNy40OTk5IDUuODMzNDFMMTYuMzMzMyA0LjY2Njc1TDcuNDk5OTIgMTMuNTAwMVoiIGZpbGw9IiMxMzlEMjkiLz4KPC9zdmc+Cg==";